import { Grid } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CssBaseline from "@material-ui/core/CssBaseline";
import Typography from "@material-ui/core/Typography";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import LabelsContext from "../../../../lang/LabelsContext";
import { getReviewStatus } from "../../../../utils/Utils";
import CopyText from "../../../system/copy-text/CopyText";
import ArticleDraftService, { ArticleDraftServiceType } from "./ArticleDraftService";
import useStyles from "./ArticleDraftStyle";

export default function ArticleDraft() {
  const classes = useStyles();

  const { articleDraftList, openSubmit, deleteArticleConfirm }: ArticleDraftServiceType = ArticleDraftService();

  const { Labels } = LabelsContext();

  return (
    <>
      <CssBaseline />
      {articleDraftList?.length === 0 && (
        <Grid>
          <Typography gutterBottom variant="h5" component="h2">
            No draft article
          </Typography>
        </Grid>
      )}
      <div className={classes.container}>
        {articleDraftList?.map((article: any) => (
          <Grid item xs={4} sm={4}>
            <Card className={classes.root}>
              <CardActionArea>
                <CardContent>
                  <Typography gutterBottom variant="h5" component="h2">
                    #{article.articleId} - {article.articleTitle}
                    <CopyText text={`#${article.articleId} ${article.articleTitle}`} />
                  </Typography>
                  <Typography>Status: {getReviewStatus(article.status, Labels)}</Typography>
                  <Typography>
                    Submitted on: {article.uploadDate[2]}/{article.uploadDate[1]}/{article.uploadDate[0]}
                    <br />
                    Last Update: {article.lastUpdate[2]}/{article.lastUpdate[1]}/{article.lastUpdate[0]}
                  </Typography>
                </CardContent>
              </CardActionArea>
              <CardActions className={classes.action}>
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  startIcon={<EditIcon />}
                  onClick={() => openSubmit(article.id)}
                >
                  {Labels.EDIT}
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  startIcon={<DeleteIcon />}
                  onClick={() => deleteArticleConfirm(article.id)}
                >
                  {Labels.DELETE}
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </div>
    </>
  );
}
